import InspectionSubmitted from './InspectionSubmitted';

export default InspectionSubmitted;
